import Packet from '../enums/Packet';
import PresenceType from '../enums/PresenceType';
import QueuedPacket from '../packets/QueuedPacket';
import RawPacket from '../packets/RawPacket';
import { v4 as uuidV4 } from 'uuid';
import ChatClient from './ChatClient';
import { CallbackHandler } from '../callbacks/handler';

export default class PresenceHandler {
  static shared = new PresenceHandler();

  private constructor() {}

  // private lastSeen = new Map<string, string>();

  clear = () => {};

  getLastSeen = (user: string): Promise<{ status: string }> => {
    let pkt: RawPacket = {};
    pkt[Packet.Keys.TYPE] = Packet.Types.PRESENCE;
    pkt[Packet.Common.USER] = user;
    pkt[Packet.Keys.ID] = uuidV4();

    return new Promise((resolve, reject) => {
      if (!ChatClient.shared.sendPacket(pkt, resolve)) {
        reject({ error: 'packet could not be sent to server' });
      }
    });
  };

  onPacketReceived = async (res: RawPacket, queued?: QueuedPacket) => {
    const user = res[Packet.Common.USER];

    const state = res[Packet.Presence.STATE] as PresenceType;

    let status = '';
    if (state === PresenceType.ONLINE) {
      status = 'Online';
    }

    queued?.resolve?.({ status: status });

    CallbackHandler.shared.callOnPresenceReceived(user, status);
  };
}
